import styled from 'styled-components';
import {MedicineBoxOutlined} from '@ant-design/icons';
import {Tooltip} from 'antd';
import {WHITE} from '../../utils/colors';

const Badge = styled.div`
    background: rgba(255, 152, 0, 0.9);
    color: ${WHITE};
    font-size: 11px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;

export default function PrescriptionBadge() {
    return (
        <Tooltip title="Este produto requer prescrição médica">
            <Badge>
                <MedicineBoxOutlined/> Receita
            </Badge>
        </Tooltip>
    );
}